import React from "react";
import { QdtContext } from "../contexts";

class QlikClearSelections extends React.Component {

  constructor(props) {
    super(props);

    // binds
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { qdtComponents } = this.props;
    qdtComponents.qAppPromise.then(app => app.clearAll());
  }

  render() {
    return (
      <button
        className="clear-selections-button"
        onClick={this.handleClick}>
        Clear selections
      </button>
    );
  }

}

export default (props) => {
  return <QdtContext.Consumer>
    {qdtComponents => <QlikClearSelections {...props} qdtComponents={qdtComponents} />}
  </QdtContext.Consumer>
};
